// src/utils/projectTime.js

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// Accepts "2024" or "2024-03". Parsed manually to avoid timezone surprises.
export function formatProjectDate(value) {
  const [year, month] = String(value).split("-").map(Number);
  return month ? `${MONTHS[month - 1]} ${year}` : `${year}`;
}

// Converts "2024" / "2024-03" to a sortable month number.
// A year-only *end* date counts as December so "2024" ends at the end of 2024.
export function toMonthIndex(value, isEnd = false) {
  const [year, month] = String(value).split("-").map(Number);
  return year * 12 + (month ? month - 1 : isEnd ? 11 : 0);
}

// Normalized, sorted ranges: [{ start: "2024-05", end: "2024-07" | null }]
export function getTimeRanges(product) {
  return (product?.time ?? [])
    .filter((range) => range?.start)
    .map((range) => ({
      start: String(range.start),
      end: range.end ? String(range.end) : null,
    }))
    .sort((a, b) => toMonthIndex(a.start) - toMonthIndex(b.start));
}

export function hasTimeframe(product) {
  return getTimeRanges(product).length > 0;
}

export function isOngoing(product) {
  return getTimeRanges(product).some((range) => !range.end);
}

// Overall span: earliest start to latest end (end is null if anything is ongoing).
export function getProjectSpan(product) {
  const ranges = getTimeRanges(product);
  if (!ranges.length) return null;

  const start = ranges[0].start;
  if (ranges.some((r) => !r.end)) return { start, end: null };

  const end = ranges.reduce((latest, r) =>
    toMonthIndex(r.end, true) > toMonthIndex(latest, true) ? r.end : latest,
    ranges[0].end
  );

  return { start, end };
}